// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Row-module__main--yrZwB {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Panel/Row.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB","sourcesContent":[".main {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Row-module__main--yrZwB`
};
export default ___CSS_LOADER_EXPORT___;
